// import React from "react";
// import { Link } from "react-router-dom";
// import FadeInCard from "./FadeInCard";

// export default function EmpowerCustomers() {
//   const cards = [
//     {
//       title: "INTELLIGENT DATA CENTER",
//       icon: "/icon1.png",
//       text: `Our infrastructure empowers enterprises to scale efficiently with top-tier hardware for AI, trading, and rendering workloads.`,
//       gradient: "from-purple-400 to-purple-600",
//       button: "Enable",
//       path: "/our-pillars",
//     },
//     {
//       title: "LOW LATENCY CONNECTIVITY",
//       icon: "/icon2.png",
//       text: `We deliver low-latency, cost-effective networking through cutting-edge telecom infrastructure and optimized routing.`,
//       gradient: "from-pink-400 to-rose-500",
//       button: "Connect",
//       path: "/our-pillars",
//     },
//     {
//       title: "ENTERPRISE ENABLEMENT",
//       icon: "/icon3.png",
//       text: `We design scalable architectures and ensure continuous availability with AI-driven predictive maintenance and optimization.`,
//       gradient: "from-fuchsia-400 to-purple-600",
//       button: "Operate",
//       path: "/our-pillars",
//     },
//   ];

//   return (
//     <section className="relative py-24 bg-gradient-to-br from-purple-50 via-white to-purple-100 text-center overflow-hidden">
//       <div className="absolute -top-32 left-10 w-80 h-80 bg-purple-300/30 rounded-full blur-3xl animate-pulse"></div>
//       <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-pink-200/40 rounded-full blur-3xl animate-pulse"></div>

//       <FadeInCard delay={0}>
//         <div className="relative z-10">
//           <h2 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-purple-700 to-fuchsia-600 bg-clip-text text-transparent mb-3">
//             EMPOWERING OUR CUSTOMERS
//           </h2>
//           <p className="text-lg font-semibold text-purple-800/80 tracking-wide mb-8">
//             OUR CORE PILLARS
//           </p>
//           <p className="text-lg font-semibold text-purple-900 tracking-wide mb-16">
//             At AI Nova, every breakthrough in compute is a breakthrough in
//             compassion. Every model <br />
//             trained helps us understand humanity better. Every partnership we
//             forge builds a bridge to a <br /> smarter, kinder, more connected
//             world.
//           </p>
//         </div>
//       </FadeInCard>

//       <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-3 gap-10 px-6">
//         {cards.map((card, i) => (
//           <FadeInCard key={card.title} delay={0.15 * (i + 1)}>
//             <div
//               className="cursor-pointer rounded-3xl bg-white/80 backdrop-blur-xl border border-white/50
//                          shadow-[0_8px_30px_rgba(138,79,255,0.1)] p-8 flex flex-col justify-between
//                          hover:-translate-y-3 hover:shadow-[0_16px_40px_rgba(138,79,255,0.25)]
//                          transition-transform ease-out duration-300"
//             >
//               <div>
//                 <div
//                   className={`relative w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-2xl
//                               bg-gradient-to-br ${card.gradient} text-4xl text-white shadow-lg`}
//                 >
//                   <div className="absolute inset-0 rounded-2xl bg-white/10 blur-lg"></div>
//                   <img
//                     src={card.icon}
//                     alt={card.title}
//                     className="relative z-10 w-12 h-12 object-contain"
//                   />
//                 </div>

//                 <h3 className="text-xl font-extrabold text-purple-900 mb-3 tracking-tight whitespace-nowrap">
//                   {card.title}
//                 </h3>
//                 <p className="text-purple-900/80 text-sm leading-relaxed text-justify">
//                   {card.text}
//                 </p>
//               </div>

//               <Link
//                 to={card.path}
//                 className="mt-8 relative mx-auto px-6 py-2 text-white font-semibold rounded-full overflow-hidden inline-block"
//               >
//                 <span
//                   className={`absolute inset-0 bg-gradient-to-r ${card.gradient} animate-[gradientMove_4s_linear_infinite]`}
//                 ></span>
//                 <span className="relative z-10">{card.button}</span>
//               </Link>
//             </div>
//           </FadeInCard>
//         ))}
//       </div>

//       <style>
//         {`
//           @keyframes gradientMove {
//             0% { background-position: 0% 50%; }
//             50% { background-position: 100% 50%; }
//             100% { background-position: 0% 50%; }
//           }
//         `}
//       </style>
//     </section>
//   );
// }
"use client";

import { useRef } from "react";
import {
  Brain,
  Network,
  Zap,
  ShieldCheck,
  Activity,
  GaugeCircle,
  LineChart,
  Users,
} from "lucide-react";
import FadeInCard from "./FadeInCard";
import FadeInOnScroll from "./FadeInOnScroll"; // 名字随便，但首字母要大写
import { Link } from "react-router-dom";

// 通用交互动效卡片：白底 + 紫色高光
function InteractiveCard({ children, className = "" }) {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;

    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -10;
    const rotateY = ((x - centerX) / centerX) * 10;

    cardRef.current.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    cardRef.current.style.transition = `transform 0.12s ease-out`;
    cardRef.current.style.boxShadow = `${-rotateY}px ${rotateX}px 26px rgba(168, 85, 247, 0.35)`;

    cardRef.current.style.setProperty("--x", `${x}px`);
    cardRef.current.style.setProperty("--y", `${y}px`);
  };

  const handleMouseLeave = () => {
    if (!cardRef.current) return;

    cardRef.current.style.transform = `perspective(800px) rotateX(0deg) rotateY(0deg)`;
    cardRef.current.style.transition = `transform 0.35s ease`;
    cardRef.current.style.removeProperty("--x");
    cardRef.current.style.removeProperty("--y");
    cardRef.current.style.boxShadow = "0 18px 40px rgba(148, 63, 255, 0.25)";
  };

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={
        "relative overflow-hidden rounded-2xl border border-[#e4ddff] bg-white text-slate-900 will-change-transform cursor-pointer " +
        className
      }
    >
      {/* 紫色高光 */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(420px circle at var(--x) var(--y), rgba(216,180,254,0.35), transparent 80%)",
          maskImage:
            "radial-gradient(320px circle at var(--x) var(--y), black 40%, transparent 100%)",
          WebkitMaskImage:
            "radial-gradient(320px circle at var(--x) var(--y), black 40%, transparent 100%)",
          transition: "background 0.2s ease",
        }}
      />
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
}

const topPillars = [
  {
    title: "INTELLIGENT",
    subtitle: "DATA CENTER",
    paragraphs: [
      "Our infrastructure empowers enterprises to scale efficiently, offering cutting-edge hardware and accelerating deployment.",
    ],
    icon: "/icon1.png",
    gradient: "from-[#7a3dd9] to-[#9b5bff]",
    cta: "Enable",
  },
  {
    title: "ENTERPRISE ENABLEMENT",
    paragraphs: [
      "We design scalable and agile compute, storage, networking, and data architectures to optimize and future-proof infrastructure.",
    ],
    icon: "/icon2.png",
    gradient: "from-[#e3509b] to-[#ff7a8a]",
    cta: "Operate",
  },
  {
    title: "LOW LATENCY CONNECTIVITY",
    paragraphs: [
      "Our scalable, high-performance connectivity solutions meet the complex operational demands of global enterprises.",
    ],
    icon: "/icon3.png",
    gradient: "from-[#ff6b79] to-[#ff9460]",
    cta: "Connect",
  },
];

// 卡片背景渐变
const topCardGradients = [
  "from-[#f3e7ff] via-[#ffffff] to-[#f5e7ff]",
  "from-[#ffe7f2] via-[#ffffff] to-[#ffe5d6]",
  "from-[#ffe6e6] via-[#ffffff] to-[#ffe6cf]",
];

export default function OurPillars() {
  return (
    <section className="w-full bg-gradient-to-b from-[#f7e6ff] via-[#ffffff] to-[#f9f5ff] text-slate-900">
      <div className="max-w-6xl mx-auto px-4 pt-16 pb-16">
        <div className="text-center mb-14">
          <FadeInOnScroll>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#252666] mb-3">
              EMPOWERING OUR CUSTOMERS
            </h2>
            <p className="text-xs sm:text-sm tracking-[0.25em] text-[#5e4ca8] font-semibold uppercase mb-8">
              OUR CORE PILLARS
            </p>
            <p className="text-lg font-semibold text-purple-900 tracking-wide mb-6">
              At AI Nova, every breakthrough in compute is a breakthrough in
              compassion. Every model <br />
              trained helps us understand humanity better. Every partnership we
              forge builds a bridge to a <br /> smarter, kinder, more connected
              world.
            </p>
          </FadeInOnScroll>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {topPillars.map((pillar, index) => {
            // const Icon = pillar.icon;
            const cardGradient = topCardGradients[index] || topCardGradients[0];

            return (
              <FadeInCard key={pillar.title} delay={index * 0.2}>
                <div className="flex flex-col items-center h-full">
                  <div className="relative z-10 -mb-10 flex flex-col items-center">
                    {/* 直接用 logo，本身保持 24x24 的占位，大小和之前整体区域一致 */}
                    <div className="w-24 h-24 flex items-center justify-center">
                      <img
                        src={pillar.icon}
                        alt={pillar.title}
                        className="w-24 h-24 object-contain"
                      />
                    </div>
                  </div>

                  <div
                    className={
                      "w-full min-h-[350px] rounded-[26px] bg-gradient-to-b " +
                      cardGradient +
                      " shadow-[0_20px_45px_rgba(188,148,255,0.35)] border border-[#f3e7ff] pt-14 pb-10 px-8 flex flex-col"
                    }
                  >
                    <h3 className="text-sm sm:text-lg font-extrabold tracking-[0.22em] text-[#18224f] mb-5 text-center">
                      {pillar.title} <br />
                      {pillar.subtitle}
                    </h3>

                    {/* 文案区域占据中间空间 */}
                    <div className="space-y-4">
                      {pillar.paragraphs.map((para, i) => (
                        <p
                          key={i}
                          className="text-md leading-relaxed text-[#192558]"
                        >
                          {para}
                        </p>
                      ))}
                    </div>

                    {/* 按钮固定在底部 & 居中 */}
                    <div className="mt-auto flex justify-center pt-6">
                      <Link to="/our-pillars">
                        <button
                          className={
                            "group relative inline-flex items-center justify-center rounded-full bg-gradient-to-r " +
                            pillar.gradient +
                            " px-8 text-xs font-semibold tracking-[0.25em] uppercase text-white h-10 " +
                            "shadow-[0_14px_30px_rgba(188,148,255,0.55)] " +
                            "transition-all duration-300 ease-out " +
                            "hover:-translate-y-0.5 hover:scale-[1.03] hover:shadow-[0_18px_38px_rgba(168,85,247,0.65)] " +
                            "active:translate-y-0 active:scale-[0.99] " +
                            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400 focus-visible:ring-offset-2"
                          }
                        >
                          {/* 高光扫过效果 */}
                          <span className="pointer-events-none absolute inset-0 overflow-hidden rounded-full">
                            <span
                              className="absolute -left-1/3 top-0 h-full w-1/2 -skew-x-12 bg-white/30 blur-sm
                     translate-x-[-120%] transition-transform duration-500
                     group-hover:translate-x-[260%]"
                            />
                          </span>

                          <span className="relative z-10">{pillar.cta}</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </FadeInCard>
            );
          })}
        </div>
      </div>
    </section>
  );
}
